// src/components/coins/BuyCoinsButton.js — opens the Coin Shop.
// Educators: "🪙 Class coin bank 250 · Buy" ; parents: "🪙 Buy coins".
// Never render this for students.

import React, { useState } from "react";
import CoinStore from "./CoinStore";
import CoinCelebration from "../celebrate/CoinCelebration";
import { useWallet } from "../../services/coinService";
import "./coinStore.css";

const BuyCoinsButton = ({ educator = false, compact = false, label }) => {
  const wallet = useWallet();
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" className={`sbl-cs-open ${compact ? "is-compact" : ""}`} onClick={() => setOpen(true)}>
        <span aria-hidden="true">🪙</span>{" "}
        {label || (educator ? <>Class coin bank <b>{(wallet.classBank || 0).toLocaleString()}</b> · Buy</> : "Buy coins")}
      </button>
      {open && <CoinStore educator={educator} onClose={() => setOpen(false)} />}
      {/* pops up when bought / earned coins land, on whichever page this is */}
      <CoinCelebration />
    </>
  );
};

export default BuyCoinsButton;
